import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; // Добавьте этот импорт
import api from '../../services/axiosConfig'; // Используем настроенный axios
import './Home.css';
import LevelProgress from '../../components/progressBar/LevelProgress';  // <-- путь подкорректируйте
import UserStatistics from '../../components/userStats/UserStatistics'; // Импортируем новый компонент
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';


// Интерфейсы для типов данных
interface UserProfile {
  username: string;
  xp: number;
  first_name: string;
  last_name?: string; // Добавлено для отображения фамилии
}

interface UserStats {
  totalLearned: number;
  masteredCount: number;
  needReviewCount: number;
}

interface PhraseStats {
  totalPhrases: number;
  masteredPhrases: number;
  needReviewPhrases: number;
}

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<UserProfile | null>(null);
  const [wordStats, setWordStats] = useState<UserStats | null>(null);
  const [phraseStats, setPhraseStats] = useState<PhraseStats | null>(null);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }
  
      try {
        const [profileRes, wordStatsRes, phraseStatsRes] = await Promise.all([
          api.get('/user/profile'),
          api.get('/user/stats'),
          api.get('/user/phrase-stats'),
        ]);
  
        setUser(profileRes.data);
        setWordStats(wordStatsRes.data);
        setPhraseStats(phraseStatsRes.data);
      } catch (err: unknown) { // Изменено с any на unknown
        if (axios.isAxiosError(err)) { // Используем axios.isAxiosError
          if (err.response) {
            setError(`Ошибка: ${err.response.status} - ${err.response.data.message}`);
          } else if (err.request) {
            setError('Ошибка: Нет ответа от сервера');
          } else {
            setError(`Ошибка: ${err.message}`);
          }
        } else {
          setError('Произошла непредвиденная ошибка');
        }
        console.error(err);
      } finally {
        setLoading(false); // Сбрасываем состояние loading после завершения запроса
      }
    };
  
    fetchData();
  }, [navigate]);
  
  const handleNavigate = (route: string) => {
    navigate(route);
  };
  return (
    <div className="home-page">
      <div className="container">
        {error && <p className="error-message">{error}</p>}

        {loading ? (
          <>
            <p className="greeting">
              <Skeleton width={200} height={22} borderRadius={12} />
            </p>
            <div style={{ marginBottom: '20px' }}>
              <Skeleton height={58} width={`100%`} borderRadius={12} />
            </div>
            <div style={{marginBottom: '20'}}>
              <Skeleton width={'100%'} borderRadius={12} height={189} /> 
            </div>
            <div className="quick-actions">
              <h2><Skeleton width={200} height={26} borderRadius={12} /></h2>
              <Skeleton height={340} width={'100%'} borderRadius={12} />
            </div>
          </>
        ) : (
          <>
            {user && (
              <>
                <p className="greeting">Привет, {user.first_name}!</p>
                <LevelProgress xp={user.xp} />
              </>
            )}

            {wordStats && phraseStats && (
              <UserStatistics wordStats={wordStats} phraseStats={phraseStats} />
            )}

            <div className="quick-actions">
              <h2>Начните обучение сейчас!</h2>
              <div className="actions-grid">
                <div className="action-btn words-game-btn" onClick={() => handleNavigate('/words-game')}>
                  Учить слова
                </div>
                <div className="action-btn phrase-game-btn" onClick={() => handleNavigate('/phrase-game')}>
                  Учить фразы
                </div>
                <div className="action-btn dictionary-btn" onClick={() => handleNavigate('/dictionary')}>
                  Словарь
                </div>
                <div className="action-btn phrases-btn" onClick={() => handleNavigate('/phrases')}>
                  Сборник фраз
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Home;